import { ColDef } from 'ag-grid-community';

export const isColDef = (value: unknown): value is ColDef => !!(value && !Object.hasOwn(value, 'children'));
